/** Demo catalog — UI only until licensed playback / cue API ships. */
export type JukeboxTrack = {
  id: string;
  title: string;
  artist: string;
  durationSec: number;
  requestCoins: number;
};

export type JukeboxQueueItem = {
  queueId: string;
  track: JukeboxTrack;
  requestedBy: string;
  bumpCoins: number;
};

export const JUKEBOX_REQUEST_COINS = 50;
export const JUKEBOX_BUMP_COINS = 20;

export const DEMO_JUKEBOX_TRACKS: readonly JukeboxTrack[] = [
  {
    id: 'trk-midnight-rope',
    title: 'Midnight Rope',
    artist: 'Velvet Circuit',
    durationSec: 214,
    requestCoins: JUKEBOX_REQUEST_COINS,
  },
  {
    id: 'trk-slow-burn',
    title: 'Slow Burn Protocol',
    artist: 'Neon Petal',
    durationSec: 198,
    requestCoins: JUKEBOX_REQUEST_COINS,
  },
  {
    id: 'trk-hands-only',
    title: 'Hands Only',
    artist: 'Coil & Echo',
    durationSec: 187,
    requestCoins: JUKEBOX_REQUEST_COINS,
  },
  {
    id: 'trk-aftercare',
    title: 'Aftercare Frequency',
    artist: 'Soft Static',
    durationSec: 241,
    requestCoins: JUKEBOX_REQUEST_COINS,
  },
  {
    id: 'trk-red-light',
    title: 'Red Light Room',
    artist: 'Glass Domme',
    durationSec: 205,
    requestCoins: JUKEBOX_REQUEST_COINS,
  },
  {
    id: 'trk-kneel',
    title: 'Kneel Tempo',
    artist: 'Pulse Manor',
    durationSec: 176,
    requestCoins: JUKEBOX_REQUEST_COINS,
  },
  {
    id: 'trk-silk-wire',
    title: 'Silk & Wire',
    artist: 'Obsidian Bloom',
    durationSec: 223,
    requestCoins: JUKEBOX_REQUEST_COINS,
  },
  {
    id: 'trk-private-line',
    title: 'Private Line',
    artist: 'Dialtone',
    durationSec: 192,
    requestCoins: JUKEBOX_REQUEST_COINS,
  },
  {
    id: 'trk-crown',
    title: 'Crown Check',
    artist: 'High Roller Hymn',
    durationSec: 208,
    requestCoins: JUKEBOX_REQUEST_COINS,
  },
  {
    id: 'trk-low-hum',
    title: 'Low Hum',
    artist: 'Basement Choir',
    durationSec: 255,
    requestCoins: JUKEBOX_REQUEST_COINS,
  },
  {
    id: 'trk-golden',
    title: 'Golden Rule',
    artist: 'Ledger Lights',
    durationSec: 184,
    requestCoins: JUKEBOX_REQUEST_COINS,
  },
  {
    id: 'trk-unspoken',
    title: 'Unspoken Safe Word',
    artist: 'Quiet Protocol',
    durationSec: 231,
    requestCoins: JUKEBOX_REQUEST_COINS,
  },
] as const;

export function formatTrackDuration(totalSec: number): string {
  const minutes = Math.floor(totalSec / 60);
  const seconds = totalSec % 60;
  return `${String(minutes)}:${String(seconds).padStart(2, '0')}`;
}
